import React from 'react';
import {
  Alert,
  AlertTitle,
  Skeleton,
} from '@mui/material';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import EditDetailForm from '../profile-details-form';

type UserViewProps = {
  partner: Partner
  isLoading: boolean
  partnerError: any
  onSubmit: (data: any) => void
  submissionError: boolean
  onCancel?: () => void
};

const EditView = ({
  partnerError,
  isLoading,
  partner,
  onSubmit,
  submissionError,
  onCancel = undefined,
}: UserViewProps) => {
  if (isLoading || !partner) {
    return (
      <Skeleton variant="rounded" height={500} />
    );
  }

  if (partnerError) {
    return (
      <Alert severity="error">
        <AlertTitle>There was an error</AlertTitle>
        There was an error getting partner data
      </Alert>
    );
  }

  return (
    <EditDetailForm
      partner={partner}
      submissionError={submissionError}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  );
};

export default EditView;
